export default __webpack_public_path__ + "media/images/bigbox-logo-38e9ba18.svg";